var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"outlined":"","tile":""}},[_c('v-card-title',[_vm._v(" Crea Nuovo Ticket ")]),_c('v-card-text',[_c('TicketsForm',{on:{"submitted":_vm.onSubmitted}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }